import { InjectionToken, Signal } from '@angular/core';

/**
 * One contract for both platforms (design D3). `initialize()` is
 * `void | Promise<void>` deliberately: the web implementation self-initializes
 * in its constructor (synchronous, idempotent), while the native implementation
 * awaits `@capacitor/network`'s async status query. `provideAppInitializer`
 * accepts both return shapes, so the union costs nothing.
 */
export interface NetworkStatusPort {
  readonly isOnline: Signal<boolean>;
  initialize(): void | Promise<void>;
}

export const NETWORK_STATUS = new InjectionToken<NetworkStatusPort>('NETWORK_STATUS');
